// extracted by mini-css-extract-plugin
export default {"showIcon":"ActionHeader_showIcon__7FAd1"};